export const MAX_SUBJECT_LENGTH = 100;
export const MAX_MESSAGE_LENGTH = 5000;
